import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

const GallerySlider = () => {
    const initSlider = () => {
        const sliders = document.querySelectorAll('.gallery-slider .swiper, .gallery-slider-container .swiper');
        if (!sliders.length) return;

        sliders.forEach(slider => {
            const container = slider.closest('.gallery-slider');
            const prevButton = container.querySelector('.gallery-slider__prev');
            const nextButton = container.querySelector('.gallery-slider__next');
            
            new Swiper(slider, {
                modules: [Navigation, Pagination, Autoplay],
                slidesPerView: 1,
                spaceBetween: 16,
                loop: true,
                speed: 600,
                preloadImages: false,
                updateOnImagesReady: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    prevEl: prevButton,
                    nextEl: nextButton,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2,
                        centeredSlides: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        centeredSlides: true,
                    },
                },
            });
        });
    };
    initSlider();
};

export default GallerySlider; 